export default "__VITE_ASSET__FhJCzjfC__"